import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Work from "@/pages/Work";
import Zimbabwe from "@/pages/Zimbabwe";
import Impact from "@/pages/Impact";
import Trustees from "@/pages/Trustees";
import Governance from "@/pages/Governance";
import GetInvolved from "@/pages/GetInvolved";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import {
  PrivacyPolicy, CookiePolicy, Safeguarding, Complaints, Accessibility,
} from "@/pages/Policies";
import { NewsletterConfirm, NewsletterUnsubscribe } from "@/pages/NewsletterPages";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminMagic from "@/pages/admin/AdminMagic";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminDonations from "@/pages/admin/AdminDonations";
import AdminNews from "@/pages/admin/AdminNews";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminSettings from "@/pages/admin/AdminSettings";

function NotFound() {
  return (
    <div className="py-32 text-center px-6">
      <h1 className="font-serif text-4xl sm:text-5xl font-medium text-forest">Page not found</h1>
      <p className="mt-4 text-charcoal/70">The page you are looking for does not exist or has moved.</p>
      <a href="/" className="mt-6 inline-block bg-forest text-white font-medium px-8 py-3 hover:bg-forest-dark transition-colors duration-300" data-testid="notfound-home-link">
        Return home
      </a>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/our-work" element={<Work />} />
            <Route path="/zimbabwe" element={<Zimbabwe />} />
            <Route path="/our-impact" element={<Impact />} />
            <Route path="/trustees" element={<Trustees />} />
            <Route path="/governance" element={<Governance />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/safeguarding" element={<Safeguarding />} />
            <Route path="/complaints" element={<Complaints />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/newsletter/confirm" element={<NewsletterConfirm />} />
            <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribe />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/magic" element={<AdminMagic />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminOverview />} />
            <Route path="donations" element={<AdminDonations />} />
            <Route path="news" element={<AdminNews />} />
            <Route path="submissions" element={<AdminSubmissions />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          <Route path="*" element={<Layout />}>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
